import Vue from "vue";
import axios from "axios";

window.app = new Vue({
  el: "#app",
  data: {
    showStepOne: true,
    showStepTwo: false,
    showStepThree: false,
    phone: "",
    showTimer: false,
    countDown: 60,
    showOtpReqBtn: false,
    newPassword: "",
    otp: "",
  },
  mounted() {},
  methods: {
    handelStepOne() {
      axios.get(`${phoneCheckingURL}?phone=${this.phone}`).then(({ data }) => {
        if (data.success) {
          this.showStepOne = false;
          this.showStepTwo = true;
          this.timer();
        } else {
          alert(data.msg);
        }
      });
    },
    handelStepTwo() {
      axios
        .get(`${otpCheckingURL}?phone=${this.phone}&otp=${this.otp}`)
        .then(({ data }) => {
          if (data.success) {
            this.showStepTwo = false;
            this.showStepThree = true;
          } else {
            alert(data.msg);
          }
        });
    },
    handelOtpBtnClick() {
      this.handelStepOne();
      this.showOtpReqBtn = false;
      this.timer();
    },
    handelConfirmPassBtn() {
      axios
        .get(
          `${changePassURL}?phone=${this.phone}&new_pass=${this.newPassword}`
        )
        .then(({ data }) => {
          if (data.success) {
            window.location.href = redirectURL;
          } else {
            alert("Something went wrong!");
          }
        });
    },
    timer() {
      this.showTimer = true;
      let countDown = this.countDown;

      let timer = setInterval(() => {
        countDown--;

        if (countDown <= -1) {
          clearInterval(timer);
          this.showTimer = false;
          this.countDown = 60;
          this.showOtpReqBtn = true;
        } else {
          this.countDown = countDown;
        }
      }, 1000);
    },
  },
});
